import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { ReconciliationDashboardService } from '@core/services/entities/reconciliation-dashboard.service';
import { SummaryReconciliationDashboardRequestDto } from '@domain/reconciliation-dashboard/dtos/summary-reconciliation-dashboard.request.dto';
import { SummaryReconciliationDashboardResponseDto } from '@domain/reconciliation-dashboard/dtos/summary-reconciliation-dashboard.response.dto';
import { Observable } from 'rxjs';
import { ReconciliationDashboardRepository } from './reconciliation-dashboard.repository';

@Injectable({
  providedIn: 'root',
})
export class ReconciliationDashboardRepositoryService
  implements ReconciliationDashboardRepository
{
  constructor(
    private reconciliationDashboardService: ReconciliationDashboardService,
  ) {}

  summarizeReconciliationDashboard(
    request: SummaryReconciliationDashboardRequestDto,
  ): Observable<ApiResponse<SummaryReconciliationDashboardResponseDto>> {
    return this.reconciliationDashboardService.summarizeReconciliationDashboard(
      request,
    );
  }
}
